import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { createClient } from '@supabase/supabase-js';

const COLORS = {
  primary: '#2D5016',
  primaryLight: '#4A7C2B',
  background: '#F5F7F3',
  text: '#2D3E1F',
  textLight: '#6B7F5C',
  border: '#D4E0CE',
  white: '#FFFFFF',
  error: '#C44536',
};

const SUPABASE_URL = 'https://ztbeipyycwswknnzqyze.supabase.co';
const SUPABASE_ANON_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Inp0YmVpcHl5Y3dzd2tubnpxeXplIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NjczMDIyNTMsImV4cCI6MjA4Mjg3ODI1M30.IeuNGgwtGZbcSF-SvbjvR4mDs82u4FW-X2F73diuiYY';


const supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY);

const Login = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      const { data, error: signInError } = await supabase.auth.signInWithPassword({
        email,
        password,
      });

      if (signInError) throw signInError;

      if (data.session) {
        // Successfully logged in, navigate to dashboard
        navigate('/dashboard');
      }
    } catch (err) {
      console.error('Login error:', err);
      setError(err.message || 'Invalid email or password');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{
      minHeight: '100vh',
      background: COLORS.background,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '2rem 1rem',
      fontFamily: 'Georgia, serif',
    }}>
      <div style={{
        maxWidth: '400px',
        width: '100%',
        background: COLORS.white,
        borderRadius: '8px',
        padding: '3rem 2rem',
        boxShadow: '0 2px 8px rgba(45, 80, 22, 0.08)',
      }}>
        <img 
          src="https://static.wixstatic.com/media/e78d43_e6a2a4d725014972851fe9dd56aeaa4b~mv2.png"
          alt="Virbal"
          style={{ maxWidth: '200px', margin: '0 auto 2rem', display: 'block' }}
        />

        <h2 style={{
          fontSize: '2rem',
          color: COLORS.text,
          marginBottom: '0.5rem',
          textAlign: 'center',
          fontWeight: 400,
        }}>Welcome back</h2>

        <p style={{
          color: COLORS.textLight,
          fontFamily: 'Inter, sans-serif',
          textAlign: 'center',
          marginBottom: '2rem',
        }}>Log in to your Virbal account</p>

        {error && (
          <div style={{
            background: '#FFF5F5',
            border: '1px solid #FED7D7',
            color: COLORS.error,
            padding: '0.75rem 1rem',
            borderRadius: '6px',
            marginBottom: '1.5rem',
            fontFamily: 'Inter, sans-serif',
            fontSize: '0.9rem',
          }}>
            {error}
          </div>
        )}

        <form onSubmit={handleSubmit}>
          <div style={{ marginBottom: '1.5rem' }}>
            <label style={{
              display: 'block',
              fontSize: '0.9rem',
              color: COLORS.text,
              marginBottom: '0.5rem',
              fontFamily: 'Inter, sans-serif',
            }}>Email</label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              style={{
                width: '100%',
                padding: '0.75rem 1rem',
                border: `2px solid ${COLORS.border}`,
                borderRadius: '6px',
                fontSize: '1rem',
                fontFamily: 'Inter, sans-serif',
                boxSizing: 'border-box',
              }}
            />
          </div>

          <div style={{ marginBottom: '2rem' }}>
            <label style={{
              display: 'block',
              fontSize: '0.9rem',
              color: COLORS.text,
              marginBottom: '0.5rem',
              fontFamily: 'Inter, sans-serif',
            }}>Password</label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              style={{
                width: '100%',
                padding: '0.75rem 1rem',
                border: `2px solid ${COLORS.border}`,
                borderRadius: '6px',
                fontSize: '1rem',
                fontFamily: 'Inter, sans-serif',
                boxSizing: 'border-box',
              }}
            />
          </div>

          <button
            type="submit"
            disabled={loading}
            style={{
              width: '100%',
              padding: '1rem',
              background: loading ? COLORS.border : COLORS.primary,
              color: 'white',
              border: 'none',
              borderRadius: '6px',
              fontSize: '1rem',
              fontWeight: 600,
              cursor: loading ? 'not-allowed' : 'pointer',
              fontFamily: 'Inter, sans-serif',
              transition: 'background 0.2s',
            }}
          >
            {loading ? 'Logging in...' : 'Log In'}
          </button>
        </form>

        <p style={{
          textAlign: 'center',
          marginTop: '1.5rem',
          color: COLORS.textLight,
          fontFamily: 'Inter, sans-serif',
          fontSize: '0.9rem',
        }}>
          Don't have an account? <a href="/signup" style={{ color: COLORS.primary, textDecoration: 'none', fontWeight: 600 }}>Sign up</a>
        </p>

        <p style={{
          textAlign: 'center',
          marginTop: '1rem',
          color: COLORS.textLight,
          fontFamily: 'Inter, sans-serif',
          fontSize: '0.9rem',
        }}>
          <a href="https://www.virbal.net" style={{ color: COLORS.primary, textDecoration: 'none', fontWeight: 600 }}>← Back to Virbal</a>
        </p>
      </div>
    </div>
  );
};

export default Login;
